import { useState } from 'react';
import { ChevronLeft} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodeBlock = ({ language = 'python', children }) => {
  return (
    <SyntaxHighlighter
      language={language}
      style={vscDarkPlus}
      showLineNumbers
      className="rounded-lg"
    >
      {children}
    </SyntaxHighlighter>
  );
};

export default function Pydamental() {
  const [activeTab, setActiveTab] = useState('section1');
  const navigate = useNavigate();
  const handleReturn = () => {
    navigate(-1);
  };
  const sections = [
    { id: 'section1', title: 'List' },
    { id: 'section2', title: 'Hash Table' },
    { id: 'section3', title: 'Tuple' },
    { id: 'section4', title: 'Set' },
    { id: 'section5', title: 'Class & Object' },
    { id: 'section6', title: 'Function' },
    { id: 'section7', title: 'String' },
    { id: 'section8', title: 'Linked list'},
    { id: 'section9', title: 'Other' },
  ];

  const renderContent = () => {
    switch(activeTab) {
      case 'section1':
        return (
          <div>
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">Python List</h2>
            {/* <p className="mb-4">这里是关于Python列表的描述和解释。</p> */}
            
            {/* 代码块示例 */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">List is mutable</h3>
              <CodeBlock>
{`a = [1, 2, 3]
b = a
b.append(4)
print(a)  # Output: [1, 2, 3, 4] since a and b are the same object`}
              </CodeBlock>
              <p>Since list is mutable, <b>don't use list as default parameter in a function</b>.</p>
              <CodeBlock>
{`def append_to_list(value, my_list=[]):
    my_list.append(value)
    return my_list
print(append_to_list(1)) # output: [1]
print(append_to_list(2)) # output: [1, 2]`}
              </CodeBlock>
              <p>The correct method is</p>
              <CodeBlock>{`def append_to_list(value, my_list=None):
    if my_list is None:
        my_list = []
    my_list.append(value)
    return my_list`}</CodeBlock>
            </div>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Copy a list</h3>
              <CodeBlock>
{`# hallow copy
a = [1, 2, 3]
b = a.copy()
c = a[:]
d = list(a)
b[0] = 999
print(a) # output: [1, 2, 3]
a = [[1, 2], [3, 4]]
b = a.copy()
b[0][0] = 999
print(a) # output: [[999, 2], [3, 4]]
# deep copy
import copy
a = [[1, 2], [3, 4]]
b = copy.deepcopy(a)
b[0][0] = 999
print(a) #output: [[1, 2], [3, 4]]`}
              </CodeBlock>
              <p>Since * method is shallow copy, take care when you use it to generate a new list. Compare the two lists:</p>

            <CodeBlock>
{`a = [[0]*3]*3
b = [[0]*3 for _ in range(3)]
a[0][0]=1 # then a = ?
b[0][0]=1 # then b = ?`}
              </CodeBlock>
            </div>


            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Insert and Pop</h3>
              <CodeBlock>
{`# pop() delete the last element; pop(0) delete the first element
# insert(0,1) insert 1 at the first element; insert(a,b) insert b at the a-th element
# remove(a) remove the first a in the list; [_ for _ in b if _ != a] remove all a in the list`}</CodeBlock>
<p>If you need to always control the beginning of the list, you should use deque method.</p>
            </div>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Sort a list</h3>
           <CodeBlock>
{`a = [2, 6, 3, 4]
b = sorted(a) # b = [2, 3, 4, 6]
a.sort() # return None
`}
           </CodeBlock>
            </div>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Check a value in a list</h3>
           <CodeBlock>
{`a = [1, 2, 3, 4]
print(2 in a)
print(2 in set(a)) # faster
`}
           </CodeBlock>
            </div>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg">
              <h3 className="text-lg font-semibold mb-2 text-yellow-800">Comments</h3>
              <p className="text-yellow-700">Shallow copy copies only the outermost object, sharing nested objects; deep copy recursively copies all levels, making them completely independent.</p>
            </div>
          </div>
        );
      
      case 'section2':
        return (
          <div>
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">Python dict</h2>
            <p className="mb-4"></p>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">dict is mutable; key is hashable</h3>
              
            </div>
            
            {/* <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg">
              <h3 className="text-lg font-semibold mb-2 text-yellow-800">注释</h3>
              <p className="text-yellow-700">字典是键值对的集合，提供O(1)时间复杂度的查找。</p>
            </div> */}
          </div>
        );
      
      case 'section3':
        return (
          <div>
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">Python tuple</h2>
            <p className="mb-4"></p>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Tuple is hashable</h3>
              
            </div>
          </div>
        );

        case 'section4':
        return (
          <div>
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">Python set</h2>
            <p className="mb-4"></p>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800"></h3>
              
            </div>
          </div>
        );

        case 'section5':
        return (
          <div>
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">Python class</h2>
            <p className="mb-4"></p>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800"></h3>
              
            </div>
          </div>
        );

        case 'section6':
        return (
          <div>
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">Python function</h2>
            <p className="mb-4"></p>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800"></h3>
              
            </div>
          </div>
        );

        case 'section7':
        return (
          <div>
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">Python string</h2>
            <p className="mb-4"></p>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Basic</h3>
              <CodeBlock>
{`str.lower() # lowercase
str.upper() # uppercase
str.capitalize() # capitalize the first character
str.title() # capitalize first character for every word
str.strip() # remove blank space of left and right sides
str.lstrip()
str.rstrip()
`}
              </CodeBlock>
              <p>All those methods won't change the string</p>
            </div>
          </div>
        );
        case 'section8':
        return (
          <div>
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">Linked list</h2>
            <p className="mb-4"></p>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800"></h3>
              In python, there is no default set linked list data structure. We can define it as follows:
              <CodeBlock>
                {`# define a listNode
class ListNode:
    def __init__(self, val=0, next=None):
        self.val = val
        self.next = next`}
              </CodeBlock>
              <CodeBlock>
{`# define a linked list
def linked_list(values):
    dummy = ListNode()
    current = dummy
    for val in values:
        current.next = ListNode(val)
        current = current.next
    return dummy.next
`}
              </CodeBlock>
              Merge two linked list:
              <CodeBlock>
                {`def merge_two_lists(l1,l2):
    dummy = ListNode()
    current = dummy

    while l1 and l2:
        if l1.val < l2.val:
          current.val = l1
          l1 = l1.next
        else:
          current.val = l2
          l2 = l2.next
        currrent = current.next
    current.next = l1 if l1 else l2
    return dummy.next`}
              </CodeBlock>
            </div>
          </div>
        );

        case 'section9':
        return (
          <div>
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">Other</h2>
            <p className="mb-4"></p>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Iterable object</h3>
              <p>loop a iterable object</p>
              <CodeBlock>
{`for item in iterable:
    print(item)`}
              </CodeBlock>
              <p>List comprehension</p>
              <CodeBlock>
                {`squares = [x**2 for x in range(10)]`}
              </CodeBlock>
              <p>Functions</p>
              <code>len(iterable)</code>: get elements length<br/>
              <code>sum(iterable)</code>: get sum<br/>
              <code>min(iterable) max(iterable)</code><br/>
              <code>sorted(iterable)</code><br/>
              <code>reversed(iterable)</code><br/>
              <code>enumerate(iterable, start=0)</code><br/>
            </div>
          </div>
        );
      default:
        return (
          <div className="text-center p-10">
            <h2 className="text-2xl font-bold mb-3 text-indigo-600">{sections.find(s => s.id === activeTab)?.title || '内容'}</h2>
            <p className="text-gray-600">在这里填写您的内容...</p>
            
            {/* 代码块模板 */}
            <div className="mb-6 mt-6 text-left">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">示例代码</h3>
              <SyntaxHighlighter 
                language="python" 
                style={vscDarkPlus}
                className="rounded-lg"
                showLineNumbers={true}
              >
{`# 这里是Python代码示例
def example_function():
    """文档字符串"""
    result = 0
    for i in range(10):
        result += i
    return result

# 调用函数
print(example_function())  # 输出: 45`}
              </SyntaxHighlighter>
            </div>
            
            {/* 注释区域模板 */}
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg text-left">
              <h3 className="text-lg font-semibold mb-2 text-yellow-800">注释</h3>
              <p className="text-yellow-700">这里可以添加相关的注释和说明...</p>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="p-6 max-w-6xl mx-auto bg-gray-50 min-h-screen">
        <div className="flex items-center justify-between mb-6">
  <button
    onClick={handleReturn}
    className="flex items-center text-gray-600 hover:text-gray-900"
  >
    <ChevronLeft className="w-5 h-5 mr-1" />
    <span>Return</span>
  </button>

  <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-indigo-700">Python Data Structure</h1>
</div>
      
      {/* 可滑动的选项卡导航 */}
      <div className="flex overflow-x-auto mb-6 bg-white rounded-lg shadow">
        {sections.map(section => (
          <button 
            key={section.id}
            className={`px-4 py-2 font-medium text-sm transition-colors duration-200 whitespace-nowrap ${
              activeTab === section.id 
                ? 'bg-indigo-600 text-white'
                : 'hover:bg-indigo-100 text-gray-700'
            }`}
            onClick={() => setActiveTab(section.id)}
          >
            {section.title}
          </button>
        ))}
      </div>
      
      {/* 内容区域 */}
      <div className="bg-white rounded-lg shadow-lg p-6">
        {renderContent()}
      </div>
      
      {/* 用法提示 */}
      {/* <div className="mt-8 bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-lg">
        <h3 className="text-lg font-semibold mb-2 text-blue-800">组件使用说明</h3>
        <ul className="list-disc pl-5 text-blue-700">
          <li>使用<code className="bg-blue-100 px-1 rounded">react-syntax-highlighter</code>库实现Python代码高亮</li>
          <li>可以通过修改顶部的<code className="bg-blue-100 px-1 rounded">sections</code>数组来添加或修改导航选项卡</li>
          <li>每个部分的内容可以在<code className="bg-blue-100 px-1 rounded">renderContent</code>函数中的相应case中修改</li>
          <li>可以根据需要更换不同的语法高亮主题，只需修改<code className="bg-blue-100 px-1 rounded">style</code>属性</li>
        </ul>
      </div> */}
    </div>
  );
}